////// Doc. //////
//////////////////

// Initialises the video.js player instance for the VideoPlayer component.

////// Lib. //////
//////////////////

import videojs from "video.js";

///// Assets /////
//////////////////

const msgs = {
  start:  ["init. player"],
  end:    ["init. player", "init. success"],
  no_el:  ["init. player", "no video element ref found — aborting"],
};

// Method def. ///
//////////////////

export default function init_player() {
  ///// Setup //////
  //////////////////

  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  const el = this.ref.videoEl;
  if (!el) {
    if (logs) console.log(...msgs.no_el);
    return;
  }

  ///// Action /////
  //////////////////

  const { autoplay, loop, controls, preload } = this.options;

  // Sources are intentionally NOT passed to video.js here.
  // Passing sources causes video.js to call resetMediaElement() → el.load()
  // internally, and Safari/WebKit resets the `muted` DOM property during load().
  // That breaks native muted autoplay regardless of any subsequent JS fix.
  //
  // Instead: the <source> element in the HTML is left untouched, and the native
  // `muted playsinline` HTML attributes are set before JS runs. video.js wraps
  // the existing element and provides the UI layer without touching the source.
  this.player = videojs(el, {
    controls,
    loop,
    preload,
    playsinline: true,
    fluid:       false,
    fill:        true,
    suppressNotSupportedError: true,
  });

  if (autoplay) {
    this.player.ready(() => this.attempt_autoplay());
  }

  //// Conclude ////
  //////////////////

  if (logs) this.player.on("ready", () => console.log(msgs.end[0], "→", msgs.end[1]));
}
